<template>
  <!-- 主要内容 begin -->
  <div id="content-main">
    <!-- 搜索 start -->
    <div class="flex-between" style="flex-flow:row wrap;">
      <div class="flex-start" style="margin-bottom:5px;">
        <div class="search-item">
          <a-input-search
            v-model="keyword"
            placeholder="搜索组"
            style="width: 200px"
            @search="search"
          />
        </div>
      </div>
      <a-button type="primary" icon="plus" @click="modalStatus_1('')"
        >创建管理组</a-button
      >
    </div>
    <a-divider dashed />
    <!-- 搜索 end -->

    <!-- 列表 start -->
    <a-table
      :columns="columns"
      :dataSource="list"
      :pagination="false"
      :loading="loading"
      size="middle"
      rowKey="pk"
    >
      <span slot="permissions" slot-scope="text">
        <template>
          <span :key="index" v-for="(item, index) in permissionList">
            <span v-if="text.indexOf(item.pk) > -1"
              >{{ item.fields.name_zh }} <a-divider type="vertical"
            /></span>
          </span>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="modalStatus_1(record)">编辑</a>
        </template>
      </span>
    </a-table>
    <!-- 列表 end -->

    <!-- 分页 -->
    <Pagination :current="current" :pageSize="pageSize" :total="total" />

    <!-- 弹出层 start -->
    <a-modal
      :title="modalName_1 ? '编辑管理组' : '创建管理组'"
      :visible="modalVisible_1"
      @ok="modalSubmit_1"
      :confirmLoading="modalLoading_1"
      @cancel="modalStatus_1"
    >
      <a-form :form="modelForm_1">
        <a-form-item
          label="名称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '必填项' }],
                initialValue: modalName_1 && modalName_1.fields.name
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="权限"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            mode="multiple"
            v-decorator="[
              'permissions',
              {
                rules: [{ required: true, message: '必填项' }],
                initialValue: modalName_1 ? modalName_1.fields.permissions : []
              }
            ]"
          >
            <a-select-option v-for="item in permissionList" :key="item.pk">{{
              item.fields.name_zh
            }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 弹出层 end -->
  </div>
  <!-- 主要内容 end -->
</template>

<script>
import Pagination from "../../admin/components/Pagination";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      // 列表配置
      loading: false,
      columns: [
        {
          title: "组名",
          dataIndex: "fields.name"
        },
        {
          title: "权限",
          dataIndex: "fields.permissions",
          scopedSlots: { customRender: "permissions" }
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      // 数据
      list: [],
      permissionList: [],
      // 查询参数
      total: 0,
      current: 1,
      pageSize: 20,
      keyword: "",
      // 弹出层
      modalLoading_1: false,
      modalVisible_1: false,
      modalName_1: "",
      modelForm_1: this.$form.createForm(this, { name: "modalForm_1" })
    };
  },
  created() {
    this.init();
    this.getList();
  },
  methods: {
    // 初始化
    init() {
      this.api.getPermissionList({}, res => {
        if (res.success) {
          this.permissionList = res.data.list;
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },
    // 刷新
    refresh() {
      this.pageSize = 20;
      this.current = 1;
      this.keyword = null;
      this.getList();
    },
    // 查询
    search() {
      this.current = 1;
      this.getList();
    },
    // 列表方法
    getList() {
      this.loading = true;
      let params = {
        limit: this.pageSize,
        current: this.current,
        keyword: this.keyword
      };
      this.api.getSystemGroupList(params, res => {
        this.loading = false;
        if (res.success) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },
    // 重新赋值登录用户信息
    getManagerInfo() {
      this.api.getManagerInfo({}, res => {
        if (res.success) {
          let permissions = [];
          for (let i = 0; i < res.data.permissions.length; i++) {
            permissions.push(res.data.permissions[i].fields.name);
          }
          console.log(permissions);
          res.data.user["permissions"] = permissions;
          res.data.user["photo"] = res.data.photo;
          res.data.user["group"] = res.data.group;
          this.$store.dispatch("setToken", res.data.user.fields.accessToken);
          this.$store.dispatch("setUser", res.data.user);
        }
      });
    },
    // 分页方法
    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    // 弹出层
    modalStatus_1(record = null) {
      this.modelForm_1.resetFields();
      this.modalVisible_1 = !this.modalVisible_1;
      this.modalName_1 = this.modalVisible_1 ? record : null;
    },
    modalSubmit_1() {
      this.modelForm_1.validateFields((err, values) => {
        this.modalLoading_1 = true;
        if (err) {
          this.modalLoading_1 = false;
          return;
        }
        if (this.modalName_1 && this.modalName_1.pk) {
          values["id"] = this.modalName_1.pk;
          this.api.updateSystemGroup(values, res => {
            this.modalLoading_1 = false;
            if (res.success) {
              this.modalStatus_1();
              this.getList();
              this.getManagerInfo();
            } else {
              this.$notification.error({
                message: "错误警告！",
                description: res.message
              });
            }
          });
        } else {
          this.api.createSystemGroup(values, res => {
            this.modalLoading_1 = false;
            if (res.success) {
              this.modalStatus_1();
              this.getList();
              this.getManagerInfo();
            } else {
              this.$notification.error({
                message: "错误警告！",
                description: res.message
              });
            }
          });
        }
      });
    }
  }
};
</script>
